var isValidNumber = function (value) {
    return typeof value === 'number' && !Number.isNaN(value);
};
export { isValidNumber };
